import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useR05Api from '../../api/useR05Api';
import { isComboTicket, isReserveTicket } from '../../utils';

import useRefundTicket from '../../hooks/useRefundTicket';
import styles from './styles.module.css';

const ReceiveRefundScreen = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { fetchOrderDetail } = useR05Api();
    const { checkRefundTicket } = useRefundTicket();
    const { t } = useTranslation();

    useEffect(() => {
        const orderId = searchParams.get('orderId');
        const orderTicketId = searchParams.get('orderTicketId');

        if (!orderId) {
            navigate('/bought', { replace: true });
            return;
        }

        void (async () => {
            try {
                let orderTicket = await fetchOrderDetail({
                    orderId: orderId,
                    orderTicketId: orderTicketId !== '' ? orderTicketId : undefined,
                });
                // 販売チケット名のキーを分離
                orderTicket = {
                    ...orderTicket,
                    saleTicketName: orderTicket?.ticketName,
                    isReserve: isReserveTicket(orderTicket),
                };
                //子券・単券の場合
                if (!isComboTicket(orderTicket)) {
                    orderTicket = {
                        ...orderTicket,
                        ...(orderTicket.comboItems.length > 0 ? orderTicket.comboItems[0] : {}),
                    };
                }

                const { isPassed, data } = await checkRefundTicket(orderTicket);
                if (isPassed) {
                    navigate('/bought/refund', { state: { orderTicket: data }, replace: true });
                }
            } catch (error) {
                console.error('Error processing refund:', error);
                navigate('/bought', { replace: true });
            }
        })();
    }, [searchParams, navigate, fetchOrderDetail, checkRefundTicket]);
    return <div className={styles.loadingTitle}>{t('loading.small-bought-ticket')}</div>;
};

export default ReceiveRefundScreen;
